import {styled} from '@linaria/react';
import React, {startTransition, useEffect, useState} from 'react';
// eslint-disable-next-line monorepo/no-relative-import, monorepo/no-internal-import
import {range} from '@aboutyou/utils/src/range';
import {COLORS} from '../../../constants/colors';

const MAX_BULLETS = 5;

export const SliderBullets: React.FC<{
  slidesNumber: number;
  currentSlide: number;
  navBtnsShown?: boolean;
  navOverSlider?: boolean;
  'data-testid': string;
  className?: string;
}> = ({
  slidesNumber,
  currentSlide,
  navBtnsShown = false,
  navOverSlider = false,
  className,
  ...rest
}) => {
  const initialValue = slidesNumber > MAX_BULLETS ? MAX_BULLETS : slidesNumber;

  const [stackStart, setStackStart] = useState(0);
  const [stackEnd, setStackEnd] = useState(initialValue - 1);

  useEffect(() => {
    if (currentSlide > stackEnd) {
      startTransition(() => {
        // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
        setStackEnd(stackEnd + 1);
        setStackStart(stackStart + 1);
      });
    }
    if (currentSlide < stackStart) {
      startTransition(() => {
        setStackEnd(stackEnd - 1);
        setStackStart(stackStart - 1);
      });
    }
  }, [slidesNumber, currentSlide, stackEnd, stackStart]);

  return (
    <BulletsContainer
      data-testid={rest['data-testid']}
      navBtnsShown={navBtnsShown}
      navOverSlider={navOverSlider}
      className={className}
      tabIndex={-1}
    >
      {slidesNumber > MAX_BULLETS && stackStart > 0 && (
        <Bullet isOnEdge={true} />
      )}
      {range(0, slidesNumber).map((_, index) => (
        <Bullet
          isCurrent={index === currentSlide}
          isOnEdge={false}
          key={`bullet-key-${index}`}
          data-testid={`${rest['data-testid']}_bullet_${index}`}
          hide={!(stackStart <= index && stackEnd >= index)}
        />
      ))}

      {slidesNumber > MAX_BULLETS && stackEnd < slidesNumber - 1 && (
        <Bullet isOnEdge={true} />
      )}
    </BulletsContainer>
  );
};

const BulletsContainer = styled.div<{
  navBtnsShown: boolean;
  navOverSlider: boolean;
}>`
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: row;
  left: 0;
  justify-content: center;
  margin: auto;
  right: 0;
  backdrop-filter: blur(6px);
  border-radius: 0.3125rem;
  padding: 0.125rem 0.25rem;
  width: fit-content;
  background: rgba(242, 242, 242, 0.1);
  bottom: ${props => {
    if (props.navBtnsShown) {
      return 'auto';
    }

    return props.navOverSlider ? '10px' : '0';
  }};
`;

const Bullet = styled.div<{
  isCurrent?: boolean;
  isOnEdge: boolean;
  hide?: boolean;
}>`
  display: ${({hide}) => (hide ? 'none' : 'block')};
  background-color: ${({isCurrent}) =>
    isCurrent ? COLORS.Black : COLORS['Grey.Shade300']};
  border-radius: 50%;
  height: ${({isOnEdge}) => (isOnEdge ? '4px' : '6px')};
  margin: 2px;
  width: ${({isOnEdge}) => (isOnEdge ? '4px' : '6px')};
`;
